import { useDisclosure } from '@chakra-ui/react';
import { IQuoteRespSchema, QuoteTypeEnum } from '@monetize/types/app';
import { formatCurrency } from '@monetize/utils/core';
import { useQuoteContext } from '../../routes/Quotes/Quote/quoteContext';
import { MButton, MDivider, MFlex, MText } from '../Monetize';
import { MLastSavedStatus } from '../Monetize/MLastSavedStatus';
import { QuoteAnalyticsV2 } from './quoteAnalytics/QuoteAnalyticsV2';

const QuoteHeaderSummaryItem = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => {
  return (
    <MFlex alignItems="center">
      <MText fontWeight="bold" mr="2">
        {label}:{' '}
      </MText>
      {children}
    </MFlex>
  );
};

export const QuoteHeaderSummary = () => {
  const {
    isReadOnly,
    isError,
    quoteData,
    quoteStateData,
    manualRenewalFormMethods,
    isInternalView,
    isQuoteSaving,
  } = useQuoteContext();
  const {
    open: isAnalyticsOpen,
    onOpen: onAnalyticsOpen,
    onClose: onAnalyticsClose,
  } = useDisclosure();
  const { quote, setQuote } = quoteData;
  const { offeringLoadingState } = quoteStateData;
  const anyOfferingLoading = Object.values(offeringLoadingState).some(
    (item) => item.isLoading,
  );

  if (!quote) {
    return null;
  }

  return (
    <MFlex alignItems="center">
      {!isReadOnly && quote.modifyDate && isInternalView && (
        <MLastSavedStatus
          isLoading={quoteData.saving || anyOfferingLoading || isQuoteSaving}
          isError={isError}
        >
          <MDivider
            orientation="vertical"
            mx="3"
            borderColor="tBlack.200"
            height="20px"
          />
        </MLastSavedStatus>
      )}

      <QuoteHeaderSummaryItem label="ARR">
        <MButton
          variant="link"
          fontSize="sm"
          fontWeight="normal"
          onClick={onAnalyticsOpen}
          size="sm"
        >
          {formatCurrency(quote?.revenueMetrics.arr, {
            currency: quote?.currency,
          })}
        </MButton>
      </QuoteHeaderSummaryItem>

      <MDivider
        orientation="vertical"
        mx="3"
        borderColor="tBlack.200"
        height="20px"
      />
      <QuoteHeaderSummaryItem
        label={quote.type === QuoteTypeEnum.AMENDMENT ? 'iARR' : 'TCV'}
      >
        <MButton
          variant="link"
          fontSize="sm"
          fontWeight="normal"
          size="sm"
          onClick={onAnalyticsOpen}
        >
          {formatCurrency(
            quote.type === QuoteTypeEnum.AMENDMENT
              ? quote?.revenueMetrics.incrementalArr
              : quote?.amount,
            { currency: quote?.currency },
          )}
        </MButton>
      </QuoteHeaderSummaryItem>

      {isAnalyticsOpen && (
        <QuoteAnalyticsV2
          quote={quote as IQuoteRespSchema}
          setQuote={setQuote}
          manualRenewalFormMethods={manualRenewalFormMethods}
          renderTrigger={() => null}
          isOpen={isAnalyticsOpen}
          onOpen={onAnalyticsOpen}
          onClose={onAnalyticsClose}
        />
      )}
    </MFlex>
  );
};
